import { render, staticRenderFns } from "./Belts.vue?vue&type=template&id=068031fe"
import script from "./Belts.vue?vue&type=script&lang=js"
export * from "./Belts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports